import { NotificationDefinition } from '../../types'
import { InvoiceAutoIssueFailedHeader } from './InvoiceAutoIssueFailedHeader'
import { InvoiceAutoIssueFailedListItem } from './InvoiceAutoIssueFailedListItem'
import { InvoiceAutoIssueFailedPreview } from './InvoiceAutoIssueFailedPreview'

export const invoiceAutoIssueFailedDefinition: NotificationDefinition = {
  listItemContent: InvoiceAutoIssueFailedListItem,
  previewHeaderContent: InvoiceAutoIssueFailedHeader,
  previewContent: InvoiceAutoIssueFailedPreview
}
